import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import bywayXTheGuardianHolidaysLogo from '~/assets/logos/byway-the-guardian-holidays-logo.svg';
import { CURRENT_PROMO } from '~/utils/promoHelper';
const PartnerBannerTheGuardianHolidays = () => {
  const $ = _c(5);
  const t = useTranslations("content.promo");
  const tCommon = useTranslations("common");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = CURRENT_PROMO();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    isPromoLive,
    termsUrl
  } = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src={bywayXTheGuardianHolidaysLogo} alt="Byway x The Guardian Holidays" height={55} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t || $[3] !== tCommon) {
    t2 = <div className="flex flex-row items-center justify-center gap-4 md:gap-6 md:justify-center p-2 text-sm text-center text-white bg-[#0074A8] z-[100] md:text-base md:text-md h-[76px]">{t1}{isPromoLive ? <p className="text-xs md:text-base">{t("banner_copy")}<a href={termsUrl} aria-label={t("aria_terms")} target="_blank" rel="noopener noreferrer" className="underline">{tCommon("learn_more")}</a>.</p> : <p className="text-xs md:text-base">{t("banner_default")}</p>}</div>;
    $[2] = t;
    $[3] = tCommon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { PartnerBannerTheGuardianHolidays };